import * as e from "react";
import { MutationObserver as c } from "./contact-channels114.js";
import { notifyManager as i } from "./contact-channels115.js";
import { noop as l, shouldThrowError as m } from "./contact-channels116.js";
import { useQueryClient as f } from "./contact-channels52.js";
function w(o, b) {
  const s = f(), [r] = e.useState(
    () => new c(
      s,
      o
    )
  );
  e.useEffect(() => {
    r.setOptions(o);
  }, [r, o]);
  const t = e.useSyncExternalStore(
    e.useCallback(
      (u) => r.subscribe(i.batchCalls(u)),
      [r]
    ),
    () => r.getCurrentResult(),
    () => r.getCurrentResult()
  ), n = e.useCallback(
    (u, a) => {
      r.mutate(u, a).catch(l);
    },
    [r]
  );
  if (t.error && m(r.options.throwOnError, [t.error]))
    throw t.error;
  return { ...t, mutate: n, mutateAsync: t.mutate };
}
export {
  w as useMutation
};
//# sourceMappingURL=contact-channels92.js.map
